<template>
  <footer class="pt-5 px-2 lg:px-4 bg-primary">
    <div class="flex justify-content-center">
      <div class="flex flex-column md:flex-row w-full lg:w-10 justify-content-center">
        <div class="w-6 md:w-3">
          <img class="w-6" src="../../assets/svg/cyclinghub_white.svg" alt="logo cyclinghub">
        </div>
        <div class="w-full md:w-8 flex flex-row">
          <div class="w-3">
            <p class="cursor-pointer"><router-link to="/">Accueil</router-link></p>
            <p class="cursor-pointer"><router-link to="/actualities">Actualités</router-link></p>
            <p class="cursor-pointer"><router-link to="/contact">Contact</router-link></p>
          </div>
          <div class="w-3">
            <!-- <p class="cursor-pointer"><router-link to="/about">À propos</router-link></p> -->
            <p class="cursor-pointer"><router-link to="/register">S'inscrire</router-link></p>
            <p class="cursor-pointer"><router-link to="/register">Se connecter</router-link></p>
          </div>
        </div>
        <div class="w-3">
          <p>Nous suivre</p>
          <div class="flex flew-wrap m-0 justify-content-start gap-4">
            <p><a href="https://www.instagram.com/cyclinghub.io" target="_blank" aria-label="lien vers instagram CyclingHub"><i class="fa-brands fa-instagram text-5xl hover-accent"></i></a></p>
            <p><a href="https://www.strava.com/clubs/cyclinghubio" target="_blank" aria-label="lien vers le compte Strave de CyclingHub"><i class="fa-brands fa-strava text-5xl hover:text-orange-500"></i></a></p>
            <p><a href="https://apps.apple.com/fr/app/cyclinghub/id6503627275" target="_blank" aria-label="lien vers application IOS de CyclingHub"><i class="fa-brands fa-app-store text-5xl hover:text-blue-400"></i></a></p>
            <p><a href="https://play.google.com/store/apps/details?id=com.levelup.cyclinghub&hl=fr" target="_blank" aria-label="lien vers application Android de CyclingHub"><i class="fa-brands fa-google-play text-5xl hover:text-blue-400"></i></a></p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-content-center pt-3">
      <p class="m-0 text-xs font-italic"> CyclingHub © {{ currentYear }} - Tous droits réservés - <span><router-link to="/terms">Mentions légales</router-link></span></p>
    </div>
  </footer>
</template>

<script setup lang="ts">

const currentYear = new Date().getFullYear();

</script>

<style scoped>
a {
  color: #fff;
}

a:hover {
  color: #ddd;
  cursor: pointer;
}

.hover-accent:hover {
  color: var(--accent);
}
</style>